import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { AnalyticsCards } from "Common/Components/AnalyticsCards/AnalyticsCards";
import ExportButton from "Common/Components/Buttons/ExportButton";
import SearchBox from "Common/Components/SearchBox/SearchBox";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import CustomStyle, { autocompleteDropdownStyles } from "Constants/Style";
import { ClipboardList, FileCheck, Clock } from "lucide-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useLocation, useParams } from "react-router-dom";
import { fetchWarehouseDropdown } from "slices/Dropdowns/Warehouse/WarehouseDropdown/thunk";
import { setSelectedWarehouse } from "slices/Dropdowns/Warehouse/WarehouseDropdown/reducer";
import { MecordColors } from "Constants/Color";
import ListingPageContainer from "Common/Components/PageContainer/ListingPageContainer";
// import { exportPendingPOCSV } from "slices/Warehouse/ItemInward/PendingPO/thunk";
import ColumnVisibilityDropdown from "Common/Components/ColumnFilteringPopUp/ColumnFilteringPopUp";
import { getWarehouseByUser } from "slices/Masters/warehosue/thunk";
import OrderPaymentListing from "./OrderPayment/OrderPaymentListing";
import RetentionPaymentListing from "./RetentionPayment/RetentionPaymentListing";
import PBGListing from "./PGB/PBGListing";
import { clearAllTableStates } from "utils/clearTableStates";
import { fetchPaymentManagementByType } from "slices/paymentmanagement/thunk";
// import PurchaseOrderss from "./PurchaseOrderListing/PurchaseOrderss/PurchaseOrderss";

interface PaymentManagementProductListingProps {
  noWrapper?: boolean;
}

const PaymentManagementProductListing: React.FC<PaymentManagementProductListingProps> = ({ noWrapper = false }) => {
  const location = useLocation();
  const dispatch = useDispatch<any>();
  const { tags: tagsParam } = useParams<{ tags?: string }>();
  // const [warehouseId, setWarehouseId] = useState<any>(null);
  const [tab, setTab] = useState(
    Number(sessionStorage?.getItem("PaymentManagementProductListingTab")) || 1
  );
  const isTagsSearchRoute = noWrapper && location.pathname.startsWith("/tags-search");
  const tagFromUrl = useMemo(() => {
    if (!tagsParam) return "";
    try {
      return decodeURIComponent(tagsParam).trim();
    } catch {
      return tagsParam.trim();
    }
  }, [tagsParam]);
  const [tagsTabSummary, setTagsTabSummary] = useState({
    loading: false,
    orderPaymentCount: 0,
    retentionCount: 0,
    pbgCount: 0,
    hasError: false,
  });

  // // Get warehouse dropdown data from Redux
  // const { warehouseByUserList, warehouseByUserLoading } = useSelector(
  //   (state: any) => state.warehouse
  // );

  // useEffect(() => {
  //   if (
  //     warehouseByUserList?.length > 0 &&
  //     warehouseId == null
  //   ) {
  //     setWarehouseId(warehouseByUserList[0].warehouse_id);
  //   }
  // }, [warehouseByUserList]);


  const handleTabChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      const newTab = newValue + 1; // MUI tabs are 0-indexed, our tabs are 1-indexed
      setTab(newTab);
      clearAllTableStates()
      sessionStorage.setItem("PaymentManagementProductListingTab", newTab.toString());
    },
    []
  );

  // Memoized callback for child component tab changes
  // const handleChildTabChange = useCallback((val: number) => {
  //   setTab(val);
  //   sessionStorage.setItem("PaymentManagementProductListingTab", val.toString());
  // }, []);

  // useEffect(() => {
  //   dispatch(getWarehouseByUser());
  // }, [dispatch]);

  useEffect(() => {
    return () => {
      if (!window.location.pathname.startsWith("/payment-management")) {
        sessionStorage.removeItem("PaymentManagementProductListingTab");
      }
    };
  }, []);

  const sectionHeader = (
    <>
      {/* <div
        className="page-content pb-4"
        style={{ backgroundColor: "rgb(233, 236, 239)" }}
      >
        <AnalyticsCards statuses={statuses} />
      </div> */}

      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 w-100">
        <div>
          <h6 className="card-title mb-0">Sales Payment Management</h6>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-between mt-1">
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={tab - 1}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                fontFamily: "'Poppins', sans-serif",
                textTransform: "none",
                color: "#555555",
                transition: "color 0.2s ease",
              },
              "& .MuiTab-root:hover": {
                color: "#d2363a",
              },
              "& .Mui-selected": {
                color: "#d2363a !important",
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#d2363a",
                height: "3px",
                transition: "all 0.3s ease",
              },
            }}
          >
            <Tab label="Sales Order Payment" />
            <Tab label="Retention Payment" />
            <Tab label="PBG" />
          </Tabs>
          <Divider
            sx={{
              mt: 0,
              borderColor: "#c35f61",
            }}
          />
        </Box>
      </div>
    </>
  );

  useEffect(() => {
    if (!isTagsSearchRoute || !tagFromUrl) return;
    let mounted = true;
    setTagsTabSummary((prev) => ({ ...prev, loading: true, hasError: false }));

    Promise.all([
      dispatch(
        fetchPaymentManagementByType({
          activeTab: "Sales Order Payment",
          page: 1,
          pageSize: 1,
          search: tagFromUrl,
          type: "tag",
          sort: "",
          order: "",
          filters: [],
        })
      ).unwrap(),
      dispatch(
        fetchPaymentManagementByType({
          activeTab: "Retention Payment",
          page: 1,
          pageSize: 1,
          search: tagFromUrl,
          type: "tag",
          sort: "",
          order: "",
          filters: [],
        })
      ).unwrap(),
      dispatch(
        fetchPaymentManagementByType({
          activeTab: "PBG",
          page: 1,
          pageSize: 1,
          search: tagFromUrl,
          type: "tag",
          sort: "",
          order: "",
          filters: [],
        })
      ).unwrap(),
    ])
      .then(([orderRes, retentionRes, pbgRes]) => {
        if (!mounted) return;
        setTagsTabSummary({
          loading: false,
          orderPaymentCount: orderRes?.rowCount ?? 0,
          retentionCount: retentionRes?.rowCount ?? 0,
          pbgCount: pbgRes?.rowCount ?? 0,
          hasError: false,
        });
      })
      .catch(() => {
        if (!mounted) return;
        setTagsTabSummary({
          loading: false,
          orderPaymentCount: 0,
          retentionCount: 0,
          pbgCount: 0,
          hasError: true,
        });
      });

    return () => {
      mounted = false;
    };
  }, [dispatch, isTagsSearchRoute, tagFromUrl]);

  const hideEntireTagsSection =
    isTagsSearchRoute &&
    !tagsTabSummary.loading &&
    !tagsTabSummary.hasError &&
    tagsTabSummary.orderPaymentCount === 0 &&
    tagsTabSummary.retentionCount === 0 &&
    tagsTabSummary.pbgCount === 0;

  if (hideEntireTagsSection) {
    return null;
  }

  const forceShowOnTagsSearch =
    isTagsSearchRoute && !hideEntireTagsSection;

  const sectionBody =
    tab === 1 ? (
      <OrderPaymentListing
        activeTab="Sales Order Payment"
        noWrapper={noWrapper}
        forceShowOnTagsSearch={forceShowOnTagsSearch}
      />
    ) : tab === 2 ? (
      <RetentionPaymentListing
        activeTab="Retention Payment"
        noWrapper={noWrapper}
        forceShowOnTagsSearch={forceShowOnTagsSearch}
      />
    ) : tab === 3 ? (
      <PBGListing
        activeTab="PBG"
        noWrapper={noWrapper}
        forceShowOnTagsSearch={forceShowOnTagsSearch}
      />
    ) : null;

  if (noWrapper) {
    return (
      <>
        {sectionHeader}
        <div className="mt-1">{sectionBody}</div>
      </>
    );
  }

  return (
    <ListingPageContainer>
      <Row id="listPage">
        <Col lg={12}>
          <Card style={{ boxShadow: "none" }}>
            <Card.Header>{sectionHeader}</Card.Header>
            <Card.Body>{sectionBody}</Card.Body>
          </Card>
        </Col>
      </Row>
    </ListingPageContainer>
  );
};

export default PaymentManagementProductListing;
